import { computed, get } from '@ember/object';

export default function isAny(arrayKey, propertyKey, value) {
  value = value || true;
  return computed(`${arrayKey}.@each.${propertyKey}`, function () {
    return get(this, arrayKey).isEvery(propertyKey, value);
  });
}
